/**
 * Right-rail sidebar on the Summary page — Resilience Score, logo uploader,
 * insights, readiness bars, and inline reminders. Pure presentation.
 */
import InsightCard from "@/components/InsightCard";
import ReadinessBar from "@/components/ReadinessBar";
import LogoUploader from "@/components/LogoUploader";
import ResilienceScore from "@/components/ResilienceScore";
import { SCORE_CAVEAT_TEXT } from "@/lib/constants";

const READINESS_KEYS = [
  "operational_flexibility",
  "communications_readiness",
  "vendor_recovery",
  "data_protection",
  "staffing_resilience",
];

export default function SummarySidebar({ id, sections, insights, readiness, access, onUpgradeClick, scoreCta }) {
  return (
    <aside className="lg:col-span-4 space-y-6">
      {/* Score is shown above the report body on mobile; keep it in the rail on desktop only. */}
      <div className="hidden lg:block">
        <ResilienceScore readiness={readiness} cta={scoreCta} />
      </div>
      <LogoUploader assessmentId={id} access={access} onUpgradeClick={onUpgradeClick} />

      <div className="rounded-xl border border-slate-200 dark:border-[#2A3438] bg-slate-50/60 dark:bg-[#192124] p-5">
        <p className="text-[11px] uppercase tracking-[0.14em] text-slate-600 dark:text-[#94A3B8]">Observations</p>
        <div className="mt-4 space-y-3">
          {insights.length === 0 ? (
            <p className="text-sm text-slate-500 dark:text-[#94A3B8]">No specific observations were flagged.</p>
          ) : (
            insights.map((ins, idx) => <InsightCard key={idx} insight={ins} index={idx} />)
          )}
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 dark:border-[#2A3438] bg-white dark:bg-[#192124] p-5">
        <p className="text-[11px] uppercase tracking-[0.14em] text-slate-600 dark:text-[#94A3B8]">Readiness Indicators</p>
        <div className="mt-4 space-y-4">
          {READINESS_KEYS.map((k) => (
            <ReadinessBar key={k} category={k} score={readiness[k] ?? 60} />
          ))}
        </div>
        <p data-testid="score-caveat" className="mt-4 text-xs text-slate-500 dark:text-[#94A3B8] leading-relaxed border-t border-slate-100 dark:border-[#2A3438] pt-3">
          {sections.score_caveat || SCORE_CAVEAT_TEXT}
        </p>
      </div>
    </aside>
  );
}
